"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class DataUnit extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'dataUnit';
        this._dataType = initParams.data_type;
        this._unitCategory = initParams.unit_category;
        this._name = initParams.name;
        this._unitType = initParams.unit_type;
        this._metaData = initParams.meta_data;
        this.__permission = initParams._permission;
        this._global = initParams.global;
    }
    set dataType(value) {
        console.error('Do not set objects this way');
    }
    setDataType(value) {
        return this.dataService.updateDataUnit(this.id, { data_type: value }, this);
    }
    get dataType() {
        return this._dataType;
    }
    set unitCategory(value) {
        console.error('Do not set objects this way');
    }
    setUnitCategory(value) {
        return this.dataService.updateDataUnit(this.id, { unit_category: value }, this);
    }
    get unitCategory() {
        return this._unitCategory;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateDataUnit(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set unitType(value) {
        console.error('Do not set objects this way');
    }
    setUnitType(value) {
        return this.dataService.updateDataUnit(this.id, { unit_type: value }, this);
    }
    get unitType() {
        return this._unitType;
    }
    set metaData(value) {
        console.error('Do not set objects this way');
    }
    setMetaData(value) {
        return this.dataService.updateDataUnit(this.id, { meta_data: value }, this);
    }
    get metaData() {
        return this._metaData;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateDataUnit(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set global(value) {
        console.error('Do not set objects this way');
    }
    setGlobal(value) {
        return this.dataService.updateDataUnit(this.id, { global: value }, this);
    }
    get global() {
        return this._global;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateDataUnit(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteDataUnit(this.id, this);
    }
}
exports.default = DataUnit;
//# sourceMappingURL=dataUnit.js.map